// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__SszHt","footer":"ReportModalFilter_footer__1DyV8"};